<script setup lang='ts'>
import { APP_ROUTER, SITE_NAME, addHost, imageTransform } from '@qctsw/common'
import { contentRemoveTags, isClient } from '@qctsw/utils'
import DetailArticle from '../components/DetailArticle.vue'
import DetailVideo from '../components/DetailVideo.vue'
import ContentLink from '../components/ContentLink.vue'
import { logicNewsDetail } from '@/logic/news/detail'
import { AD_KEY } from '~/server/modules/ad/types'
import { getAllCarSeriesApi } from '~/server'
import carStore from '@/stores/car'

// TODO：应该将文章详情中的是否关注和收藏单独使用接口在客户端查询，以便ssr缓存页面数据

const {
  state,
  id,
  detailData,
  getDetail,
} = logicNewsDetail()

const dataType = 'news'
const detailType = computed(() => {
  return String(detailData.value?.articleFormatCode)
})

useActivated({
  activatedFn: () => {
    useCommonFavoriteOrCollectEvent().reset()
    useCommonFavoriteOrCollectEvent().on((data) => {
      if (!detailData.value)
        return
      if (data.type === 'favorite') {
        detailData.value.good = !detailData.value.good
        detailData.value.goodCount += detailData.value.good ? 1 : -1
      }
      else if (data.type === 'collect') {
        detailData.value.collect = !detailData.value.collect
      }
    })
  },
  deactivatedFn: () => {
    useCommonFavoriteOrCollectEvent().reset()
  },
})

const { qrcode, getQrcode } = useMiniProgramQrcode()
if (isClient)
  getQrcode({ page: 'subpages/pages/index/detail', scene: `${id.value}`, envVersion: 'release' })

await getDetail(id.value)

if (detailData.value?.articleFormatCode === 0) {
  const articleContent = await carStore().formatContent(detailData.value.articleContent)

  detailData.value.articleContent = articleContent
}
process.server && detailData.value && useSeoMeta({
  title: `${detailData.value.title} - ${SITE_NAME}`,
  ogTitle: `${detailData.value.title} - ${SITE_NAME}`,
  description: contentRemoveTags(detailData.value.articleContent).slice(0, 200),
  ogDescription: contentRemoveTags(detailData.value.articleContent).slice(0, 200),
  ogImage: addHost(detailData.value.coverImgUrl),
  ogType: 'article',
})

onMounted(() => {
  process.client && detailData.value?.articleFormatCode === 3 && toLinkHref()
})

function toLinkHref() {
  const dom = document.createElement('a')

  dom.href = detailData.value?.articleContent || ''
  dom.target = '_blank'
  dom.click()
}
</script>

<template>
  <div bg-slate-1>
    <div class="public-container public-page flex">
      <!-- 优化seo 搜索采集 -->
      <!--
         <img
        class=" absolute -z-999 w-484px h-300px" :alt="detailData?.title" :title="detailData?.title" :src="imageTransform(detailData?.coverImgUrl, {
          width: 484, height: 300,
        })"
      >
      -->

      <div class="flex-grow min-w-0">
        <!-- TODO:D1 -->
        <BaseAd :ad-key="AD_KEY.D1" />

        <div class="bg-white rounded-md p-sm overflow-hidden relative">
          <UtilLoadState :state="state" :reload-handler="() => getDetail(id)">
            <template v-if="detailData">
              <div v-if="detailData.original" class="tips">
                原创
              </div>
              <!-- video | audio -->
              <template v-if="['2', '1'].includes(detailType)">
                <DetailVideo
                  :detail-data="detailData"
                  :data-id="id"
                  :data-type="dataType"
                  :is-show-share="true"
                  :qrcode="qrcode"
                />
              </template>
              <!-- article | link -->
              <template v-else>
                <DetailArticle
                  :detail-data="detailData"
                  :data-id="id"
                  :data-type="dataType"
                  :is-show-share="true"
                  :qrcode="qrcode"
                />
              </template>
              <div class="mb-sm">
                <ContentLink
                  v-if="detailData?.complains && detailData?.complains.length"
                  title="相关投诉"
                  :link="APP_ROUTER.complaintDetail('')"
                  :data-list="detailData.complains"
                />
                <ContentLink
                  v-if="detailData?.collectives && detailData?.collectives.length"
                  title="相关集体投诉"
                  :link="APP_ROUTER.collectiveDetail('')"
                  :data-list="detailData.collectives"
                />
              </div>
              <div class="bg-slate-1 p-sm rounded text-slate-5 mt-sm indent-2em">
                网站部分文章为转载，仅供参考。版权和著作权归原作者所有，转载目的在于传递更多信息，不代表本站赞同其观点和对其真实性负责。 如有侵权请邮箱联系本站工作人员
                (<a href="mailto:admin@qctsw.com" class="text-blue-5 font-mono">admin@qctsw.com</a>) 。
              </div>
              <div class="bg-slate-1 p-sm rounded text-slate-5 mt-sm flex">
                <img class="flex-shrink-0 mr-sm w-20 h-20" src="/images/qctsw_open_qrcode.jpg" fit="fill">
                <div class="word-2">
                  第一时间获取QCTSW行业新鲜资讯和深度商业分析，请在微信公众账号中搜索「汽车投诉网」或者「qctswcom」，或用手机扫描左方二维码，即可获得汽车投诉网每日精华内容推送和最优搜索体验，并参与编辑活动。
                </div>
              </div>
              <!-- TODO:D2 -->
              <BaseAd :ad-key="AD_KEY.D2" />
              <UtilCommentOperation
                v-if="String(detailData.articleFormatCode) !== '3'"
                class="mt-sm"
                :is-good="detailData.good"
                :is-collect="detailData.collect"
                :data-id="Number(id)"
                :data-type="dataType"
              />
            </template>
            <BasicEmpty v-else />
          </UtilLoadState>
        </div>
        <ClientOnly>
          <div v-if="detailType !== '3' && detailData" class="bg-white rounded-md mt-lg p-sm">
            <LayoutComment :data-id="Number(id)" :data-type="dataType" />
          </div>
        </ClientOnly>
      </div>
      <div class="flex-shrink-0 w-[calc(100%-53rem)] pl-xl">
        <ClientOnly>
          <!-- TODO:D3 -->
          <BaseAd :ad-key="AD_KEY.D3" />
          <RankNewsAuthor
            v-if="detailData && detailData.authorId"
            class="mb-sm"
            :author-id="detailData.authorId"
            :author-head-img="detailData.authorHeadImg || ''"
            :author-name="detailData.authorName"
          />
          <RankHotNews :embedded="false" class="mb-sm" />
          <RankAuthorCorrelation :embedded="false" class="sticky top-25" />
        </ClientOnly>
      </div>
      <UtilShareFixed />
    </div>
  </div>
</template>

<style lang='scss' scoped>
.tips {
  --uno: w-40 text-center text-white bg-blue-5  px-sm py-1 absolute top-12px -left-50px -rotate-z-45 font-bold;
}
</style>
